// i18n area 'networks' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.hy-AM.meta.json.
import type { enUS } from './networks'

export const hyAM: typeof enUS = {
  networks: {
    common: {
      name: 'Անուն',
      scope: 'Սկոուպ',
      operState: 'Վիճակ',
      actions: 'Գործողություններ',
      create: 'Ստեղծել',
      close: 'Փակել',
      cancel: 'Չեղարկել',
      delete: 'Ջնջել',
      edit: 'Խմբագրել',
      save: 'Պահպանել',
      editError: 'Փոփոխությունը չհաջողվեց',
      search: 'Որոնեք ըստ անվան',
      empty: 'Այստեղ դեռ ոչինչ չկա',
      saveError: 'Չհաջողվեց պահպանել',
      loadError: 'Չհաջողվեց բեռնել — TVirt բեքենդը հասանելի՞ է',
      createError: 'Ստեղծումը չհաջողվեց',
      deleteError: 'Ջնջումը չհաջողվեց',
      deleteConfirmTitle: 'Ջնջե՞լ {name}-ը',
      deleteConfirmBody: 'Գործողությունն անշրջելի է։',
      nameHint: 'Փոքրատառեր, թվանշաններ և գծիկներ (DNS-1123)',
      up: 'Ակտիվ',
      down: 'Ոչ ակտիվ',
      unknown: 'Անհայտ',
      usedByVMs: 'VM-ներ',
      emptyTable: 'Գրառումներ չկան — ավելացրեք մեկը + կոճակով'
    },
    dialogTabs: {
      general: 'Ընդհանուր',
      base: 'Հիմնական սահմանում',
      advanced: 'Ընդլայնված կոնֆիգուրացիա',
      reserved: 'TVirt-ին վերապահված միջակայքեր',
      position: 'Դիրք',
      network: 'Ցանցի կոնֆիգուրացիա',
      hosts: 'Մասնակից հանգույցներ'
    },
    reservedRanges: {
      note: 'Սրանք TVirt-ին վերապահված IP միջակայքերն են, որոնք այն կարող է օգտագործել VM-ներին, կոնտեյներներին և այլնին ավտոմատ հասցե նշանակելու համար։ ՆՇՈՒՄ. այս միջակայքերի հասցեները TVirt-ից դուրս չպետք է օգտագործվեն արտաքին ծառայությունների կամ սարքերի կողմից։',
      from: 'Սկսած',
      to: 'Մինչև'
    },
    overlay: {
      title: 'Օվերլեյ ցանցեր',
      createTitle: 'Ստեղծել օվերլեյ ցանց',
      editTitle: 'Խմբագրել օվերլեյ ցանցը',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — դատարկ լինելու դեպքում նշանակվում է ավտոմատ',
      subnet: 'Ենթացանց',
      subnetHint: 'Օվերլեյի CIDR-ը — IPAM-ն ինքնաբերաբար ածանցում է դրանից իր ռեգիստրի գրառումը',
      mtu: 'MTU',
      weight: 'Կշիռ',
      ceilMbps: 'Առաստաղ (Mbps)',
      fairnessHint: 'Կշիռը գործում է միայն մրցակցության դեպքում. ազատ կապով ամեն ցանց կարող է օգտագործել ամբողջ թողունակությունը։ Առաստաղը, սակայն, միշտ գործում է։',
      contention: 'Մրցակցություն',
      contentionTip: 'Առնվազն մեկ հանգույց այս ցանցի դասի վրա նկատում է կորուստներ կամ overlimit-ներ՝ հերթի ՀԵՏ միասին. uplink-ի թողունակությունը վիճարկվում է, և կշիռները գործում են։ Որքան և երբվանից՝ հանգույցի net.shaping.* շարքերում։',
      firewallPolicy: 'Ֆայրվոլի քաղաքականություն',
      hosts: 'Հոսթեր',
      hostsTitle: 'Մասնակից հանգույցներ',
      hostsHint: 'Յուրաքանչյուր հանգույց հայտարարում է իր անդերլեյ վերջնակետը — ընտրություն հանգույցի ԻՐԱԿԱՆ հասցեներից՝ կարդացված նրա ցանցի կոնֆիգուրացիայից. ոչ պարտադիր օվերլեյ հասցեն պետք է լինի ենթացանցի ներսում։ Մասնակցությունը տեղաբաշխման բազմությունն է։',
      hostNode: 'Հանգույց',
      hostUnderlay: 'Անդերլեյ IP',
      hostUnderlayPickNode: 'Նախ ընտրեք հանգույցը',
      hostAddress: 'Հասցե օվերլեյում (ոչ պարտադիր)',
      hostAddressOutside: 'Overlay-ի ենթացանցից դուրս ({cidr})',
      addHost: 'Ավելացնել հանգույց',

      // Ռաունդ #156 (ստանդարտ երկխոսություն). մանրամասների երկխոսության դիտարկված տողերը:
      observedAt: 'Դիտարկվել է',
      attachedNics: 'Կցված NIC-եր'
    },
    services: {
      title: 'Ցանցային ծառայություններ',
      createTitle: 'Ստեղծել ցանցային ծառայություն',
      editTitle: 'Խմբագրել ցանցային ծառայությունը',
      kind: 'Տեսակ',
      kindCategory: 'Ծառայություններ',
      selectKindHint: 'Ընտրեք ծառայության տեսակը — ներքևում աշխատող դեմոնը իրականացման մանրուք է, որը TVirt-ը կառավարում է ձեզ համար։',
      kindLabel: {
        dhcp: 'DHCP սերվեր',
        ntp: 'NTP սերվեր',
        vpn: 'VPN սերվեր',
        dns: 'DNS սերվեր',
        gateway: 'Դարպաս',
        'lb-rp': 'Բեռնահավասարակշռիչ և հակադարձ պրոքսի',
        floatip: 'Լողացող IP'
      },
      kindDesc: {
        dhcp: 'Հասցեներ է բաժանում մատուցվող ենթացանցերում — պուլերն ածանցվում են ցանցի ենթացանցից, դարպասից և TVirt-ին վերապահված միջակայքերից։',
        dns: 'Հեղինակազոր DNS հայտարարված զոնաների վրա — գրառումներն ածանցվում են IPAM-ից՝ գումարած ձեր ձեռքով ավելացրածները։',
        gateway: 'Հանգույցը դարպաս է դառնում ցանցի համար — NAT (DNAT, 1:1, SNAT/masquerade) գումարած ստատիկ երթուղավորում կցված ցանցերի միջև, ինքնավերականգնվող՝ ըստ նախագծի։',
        'lb-rp': 'Բեռնաբալանսավորիչ / հակադարձ պրոքսի ձեր ծառայությունների առջև — L4 կամ L7 լսողներ անդամների պուլերի կամ Pod-ի պատրաստ օրինակների վրա, վերակազմաձևված ընթացքում։',
        ntp: 'Ցանցերի ժամանակի ծառայությունը — արտաքին վերադաս սերվերների վերահաղորդում, կամ հանգույցի սեփական ժամացույցը՝ մատուցված կլիենտներին։',
        vpn: 'VPN կոնցենտրատոր հանգույցի վրա — WireGuard կամ OpenVPN, ընտրում եք դուք. հեռավոր մուտք շրջիկ կլիենտների համար, կամ site to site թունել երկու ցանցերի միջև։',
        floatip: 'Մեկ հասցե, որը միաժամանակ նստում է միայն մեկ առողջ App օրինակի կամ Pod-ի վրա և տեղափոխվում է հաջորդ առողջ թիրախին, երբ այն ընկնում է — failover առանց դեմոնների. բալանսավորումը մնում է բեռնաբալանսավորիչին։'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Լողացող IP-ն ապրում է ընտրված ցանցում որպես ԼՐԱՑՈՒՑԻՉ հասցե պահող օրինակի սեփական անվանատարածքում. ոչ պորտեր, ոչ բալանսավորում, ոչ NAT — հաճախորդի IP-ն մնում է իրական։',
        address: 'Լողացող IP',
        targets: 'Թիրախներ',
        targetsHint: 'ՆԱԽԱՊԱՏՎՈՒԹՅԱՆ կարգով. առաջին առողջ թիրախը պահում է հասցեն։ Pod-ը նշանակում է իր բոլոր օրինակները՝ ըստ կրկնօրինակի. յուրաքանչյուր թիրախ ունի իր առողջության չափանիշը։ Յուրաքանչյուր թիրախ պետք է կցված լինի նույն ցանցին։',
        targetKind: 'Թիրախ',
        targetApp: 'App օրինակ',
        targetPod: 'Pod (բոլոր օրինակները)',
        targetRef: 'Որը',
        health: 'Առողջություն',
        healthRunning: 'Աշխատում է (յուրաքանչյուր կոնտեյներ պատրաստ)',
        healthTcp: 'TCP կապ',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Պորտ',
        path: 'Ուղի',
        addTarget: 'Ավելացնել թիրախ',
        moveUp: 'Տեղափոխել վերև',
        moveDown: 'Տեղափոխել ներքև',
        preempt: 'Preempt',
        preemptHint: 'Անջատված (լռելյայն). առողջ պահողը պահում է հասցեն, նույնիսկ երբ ավելի բարձր թիրախը վերադառնում է — առանց տատանման։ Միացված. առաջին առողջ թիրախը միշտ պահում է այն։',
        holder: 'Պահող',
        noHolder: 'առողջ թիրախ չկա',
        since: 'սկսած',
        verdicts: 'Դիտարկված թիրախներ',
        healthy: 'առողջ',
        unhealthy: 'ոչ առողջ',
        noVerdict: 'Դեռ որոշված չէ — հեղինակության հանգույցը գրում է առաջին վճիռը իր հաջորդ անցման ժամանակ։',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Այս օրինակը պահում է {service} ծառայության {address} լողացող IP-ն'
      },
      poolSource: 'Վերջնակետեր',
      poolSourceMembers: 'Ստատիկ անդամներ',
      poolSourcePod: 'Pod-ի պատրաստ օրինակները',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Պորտ',
      poolBackendHint: 'Վերջնակետերը հետևում են Pod-ին. օրինակը մտնում է, երբ աշխատում է յուրաքանչյուր կոնտեյներով պատրաստ, և անմիջապես դուրս է գալիս, երբ նվազեցվում է կամ մահանում։ Ակտիվ ստուգումը լռելյայն միացված է։',
      poolBackendCount: '{pod} Pod-ի պատրաստ օրինակները {port} պորտում',
      node: 'Հանգույց',
      enabled: 'Ակտիվացված',
      parked: 'Կայանված',
      subnets: 'Ենթացանցեր',
      subnetsHint: 'Այս ինստանսի մատուցած IPAM ենթացանցերը — պուլերն ածանցվում են CIDR-ից, դարպասից և TVirt-ին վերապահված միջակայքերից',
      noSubnets: 'IPAM ենթացանցեր չկան — նախ հայտարարեք ֆաբրիկայի տրամաբանական ցանց (կամ օվերլեյ ենթացանց). IPAM-ն ածանցվում է դրանցից',
      iface: 'Ունկնդրման ինտերֆեյս',
      ifaceHint: 'Հոսթի ինտերֆեյսը, որի վրա ծառայությունը բացում է իր սոկետը (օր.՝ կամուրջ) — պարտադիր է. ցանցային ծառայությունն ինքնամփոփ է, «բոլոր ինտերֆեյսները» այլևս գոյություն չունի',
      dns: 'DNS սերվերներ',
      domain: 'Դոմեն',
      detail: 'Մատուցում է',
      subnetCount: '{n} ենթացանց',
      zones: 'Զոնաներ',
      zonesHint: 'Միայն հեղինակազոր — դեմոնը երբեք ռեկուրսիա չի անում։ A գրառումներն ածանցվում են հղված IPAM ենթացանցերում հանգույցների հայտարարված հասցեներից. reverse փոխարկիչը մատուցում է նաև համապատասխան in-addr.arpa զոնաները (PTR)։ Զոնան մատուցվում է առավելագույնը մեկ DNS ինստանսի կողմից ամբողջ նավատորմում։ Ոչ պարտադիր nameserver-ը FQDN-ն է, որը գրվում է NS/SOA գրառումներում լռելյայն ns.<զոնա>-ի փոխարեն. եթե այն ընկնում է զոնայի ներսում, նրա A գրառումը միևնույն է ածանցվում է մատուցող հանգույցից։',
      zoneName: 'Զոնայի անուն',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM ենթացանցեր',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Ձեռքով գրառումներ',
      zoneRecordsHint: 'Մեկը՝ մեկ տողում. անուն ՏԵՍԱԿ արժեք — տեսակները՝ A, CNAME, MX, TXT։ Անվան բախման դեպքում ձեռքով գրառումը հաղթում է ածանցվածին։',
      addZone: 'Ավելացնել զոնա',

      // lb-rp (ալիք 3, հիմքեր). ունկնդիրներ ներկառուցված պուլերի վրա — առանց
      // engine-ի, վերակարգավորվում են աշխատանքի ընթացքում:
      lbListeningHint: 'Ինստանսը հայտարարում է ՄԵԿ ունկնդրման ցանց և ՄԵԿ հասցե — ամեն ունկնդիր կապում է այն իր պորտի վրա. երկրորդ հասցեն երկրորդ ծառայություն է։',
      listeners: 'Ունկնդիրներ',
      listenersHint: 'Ամեն ունկնդիր կապում է ինստանսի հասցեն իր պորտի վրա L4 (TCP passthrough — բայթերը երբեք չեն բացվում) կամ L7 (HTTP) ռեժիմով և փոխանցում ստորև բերված պուլերից մեկին։ Հասցե/պորտ զույգը մատուցվում է առավելագույնը մեկ ինստանսի կողմից ամեն հանգույցի վրա։ Փոփոխությունները կիրառվում են աշխատանքի ընթացքում — առանց վերագործարկման, առանց կորած միացումների։',
      listenerName: 'Անուն',
      listenerMode: 'Ռեժիմ',
      modeL7: 'L7 — HTTP հակադարձ պրոքսի',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Պորտ',
      listenerPool: 'Պուլ',
      addListener: 'Ավելացնել ունկնդիր',
      pools: 'Պուլեր',
      poolsHint: 'Բեքենդները, որոնց վրա վայրէջք է անում թրաֆիկը. ստատիկ անդամներ՝ հավասարակշռված round-robin կամ ամենաքիչ զբաղվածով, ընտրովի ակտիվ առողջության ստուգումով, որը հիվանդ անդամներին հանում է ռոտացիայից։',
      poolName: 'Անուն',
      poolAlgorithm: 'Ալգորիթմ',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Ամենաքիչ զբաղվածը',
      poolCheck: 'Առողջության ստուգում',
      checkNone: 'Ոչ մի',
      checkTcp: 'TCP միացում',
      checkHttp: 'HTTP',
      poolCheckPath: 'Զոնդի ուղի',
      poolInterval: 'Ինտերվալ (վ)',
      poolMembers: 'Անդամներ',
      poolMembersHint: 'Մեկը՝ մեկ տողում. հասցե:պորտ, ցանկության դեպքում՝ կշիռ (1-128) — օր.՝ 10.0.0.21:8080 2',
      addPool: 'Ավելացնել պուլ',
      memberCount: '{n} անդամ',

      // ntp (ntp ռաունդ — վավերացվել է 2026-08-03, ընտանիքի վերջին kind-ը).
      // ռեժիմը՝ խոսակցական բառերով, upstream ցուցակը միայն այնտեղ, որտեղ այն
      // ինչ-որ բան նշանակում է, ունկնդրման կցումը վերօգտագործում է դարպասի պիտակները:
      // #239 (ինքնամփոփ netsvc). dns և ntp kind-երի ունկնդիրների ցուցակի
      // ընդհանուր խմբագրիչը — երկու վավերացված բազմացանց բացառությունները:
      listen: {
        assignment: 'Նշանակում',
        assignmentStatic: 'Ստատիկ հասցե',
        assignmentAuto: 'Ավտոմատ (TVirt-ի պահուստավորված միջակայքեր)',
        autoHint: 'TVirt-ը հասցեն քաշում է տրամաբանական ցանցի պահուստավորված միջակայքերից և պահում է sticky — երբեք նորից չի քաշվում խմբագրման կամ failover-ի ժամանակ։',
        title: 'Ունկնդիրներ',
        hint: 'Ցանցային ծառայությունն ինքնամփոփ է. ամեն ունկնդիր հայտարարում է իր ցանցը (օվերլեյ, ֆաբրիկայի տրամաբանական ցանց կամ հում ինտերֆեյս) և հասցե՝ իր ենթացանցի ներսում — մեկ ունկնդիր՝ մեկ հասցեի, համընդհանուր ունկնդիրն այլևս գոյություն չունի։ DNS-ը և NTP-ն կարող են ունկնդրել մի քանի ցանցերի և այդ ցանցերի մի քանի հասցեների վրա։',
        address: 'Ունկնդրման հասցե',
        add: 'Ավելացնել ունկնդիր'
      },
      ntp: {
        mode: 'Համաժամեցման ռեժիմ',
        modeRelay: 'Արտաքին սերվերների վերահաղորդում',
        modeNodeClock: 'Հանգույցի սեփական ժամացույցը',
        modeHint: 'Վերահաղորդումը մատուցում է հայտարարված վերադաս սերվերներից վերցված ժամանակը. հանգույցի սեփական ժամացույցը մատուցում է մատուցող հանգույցի ժամանակը — որը կլաստերը միևնույն է պահում է համաժամեցված',
        servers: 'Վերադաս սերվերներ',
        serversHint: 'Ստորակետով բաժանված — հոսթի անուն կամ IP հասցե. ծառայությունն այստեղից է վերցնում ժամանակը և մատուցում ցանցին',
        port: 'Ունկնդրման պորտ',
        listening: 'Ունկնդրում է'
      },

      vpn: {
        engine: 'Շարժիչ',
        engineHint: 'Ընտրում եք դուք, և այն այլևս չի փոխվում. WireGuard-ը ժամանակակից է, արագ և in-kernel; OpenVPN-ը համատեղելիության վետերանն է (TCP, թշնամական ցանցեր)',
        engineLocked: 'Շարժիչն անփոփոխ է — այլ շարժիչ նշանակում է նոր ծառայություն. բանալիներն ու վկայագրերը տեղափոխելի չեն',
        mode: 'Ռեժիմ',
        modeRemote: 'Հեռավոր մուտք',
        modeSite: 'Site to site',
        modeHint: 'Հեռավոր մուտքը շրջիկ կլիենտներին տալիս է հասցե թունելում. site to site-ը միացնում է երկու ցանց',
        port: 'Ունկնդրման պորտ',
        protocol: 'Տրանսպորտ',
        protocolWireguardHint: 'WireGuard-ը խոսում է միայն UDP',
        tunnelSubnet: 'Թունելի ենթացանց',
        tunnelSubnetHint: 'Ցանցը, որտեղ ապրում են կլիենտները — գրանցված IPAM ռեգիստրում, ծնվում և մեռնում է այս ծառայության հետ',
        dnsServers: 'Կլիենտներին փոխանցվող DNS',
        routes: 'Կլիենտներին փոխանցվող երթուղիներ',
        routesHint: 'Ստորակետով բաժանված ցանցեր, որոնք հասանելի են թունելով. թունելի ենթացանցը միշտ ներառված է',
        peers: 'Պիրեր',
        peersHint: 'Թողեք հանրային բանալին դատարկ, և TVirt-ը կգեներացնի զույգը — ապա կհանձնի այն պրոֆիլի արտահանման հետ։ Տեղադրեք բանալի, և պիրը կպահի իրենը։',
        clients: 'Կլիենտներ',
        clientsHint: 'Ամեն կլիենտ ստանում է այս ծառայության սեփական CA-ի թողարկած վկայագիր։ Կլիենտին հեռացնելը ԵՏ Է ԿԱՆՉՈՒՄ այն. CRL-ն անմիջապես վերագեներացվում է։',
        peerName: 'Անուն',
        publicKey: 'Հանրային բանալի',
        publicKeyMinted: 'Գեներացնում է TVirt-ը',
        peerAddress: 'Հասցե թունելում',
        peerAddressHint: 'Դատարկ = նշանակվում է',
        allowedIps: 'Հեռավոր ենթացանցեր',
        allowedIpsHint: 'Ստորակետով բաժանված, երթուղավորվում են այս պիրի միջով',
        endpoint: 'Վերջնակետ',
        presharedKey: 'Նախապես կիսված բանալի',
        keepalive: 'Keepalive (վ)',
        addPeer: 'Ավելացնել պիր',
        addClient: 'Ավելացնել կլիենտ',
        auth: 'Նույնականացում',
        authTls: 'Վկայագրեր (TLS)',
        remote: 'Հեռավոր վերջնակետ',
        remoteHint: 'Հեռավոր ծայրի հոսթ:պորտ — դատարկը նշանակում է, որ այս կողմը սպասում է',
        peerRoutes: 'Հեռավոր ենթացանցեր',
        serverPublicKey: 'Այս սերվերի հանրային բանալին',
        ca: 'Վկայագրման մարմին',
        listening: 'Ունկնդրում է',
        tunnel: 'Թունել',
        peerCount: '{n} պիր',
        download: 'Ներբեռնել պրոֆիլը',
        downloadError: 'Չհաջողվեց արտահանել պրոֆիլը',
        lastHandshake: 'Վերջին ձեռքսեղմումը',
        never: 'երբեք',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Միացված',
        idle: 'Անգործ'
      },

      // Դարպաս (ալիք 3 — ծնվել է որպես nat, վավերացվել է 2026-08-01/02;
      // վերանվանվել և ընդլայնվել է 2026-08-03-ին). NAT կանոնների երեք
      // ընտանիքները՝ գումարած ստատիկ երթուղիներ ունկնդրման ցանցի վրա:
      // Ամեն վավերացված ձև աջակցվում է:
      gateway: {
        attach: 'Ունկնդրման ցանցի տեսակ',
        attachOverlay: 'Օվերլեյ ցանց',
        attachNetwork: 'Ֆաբրիկայի տրամաբանական ցանց',
        attachInterface: 'Հում ինտերֆեյս',
        overlay: 'Օվերլեյ ցանց',
        network: 'Տրամաբանական ցանց',
        interface: 'Ինտերֆեյսի անուն',
        interfaceHint: 'Հոսթի ինտերֆեյս, որը TVirt-ը չի կառավարում — հասցեն ընդունվում է առանց ստուգման',
        address: 'Ունկնդրման հասցե (դարպաս)',
        addressHint: 'Դարպասի հասցեն, որին ուղղվում են կլիենտները — ունկնդրման ցանցի ենթացանցի ներսում',
        dnatTitle: 'DNAT կանոններ',
        dnatHint: 'Նշանակետի NAT. համընկնող թրաֆիկը վերաուղղորդվում է նոր հասցեի (և ցանկության դեպքում՝ նոր պորտի)։ Ցուցակի ցանկացած արձանագրություն — պորտերը՝ որտեղ արձանագրությունը դրանք կրում է։',
        snatTitle: 'SNAT կանոններ',
        snatHint: 'Աղբյուրի NAT. համընկնող թրաֆիկը դուրս է գալիս վերագրված աղբյուրով — բացահայտ նոր հասցե (և ցանկության դեպքում՝ նոր պորտ), կամ masquerade ելքի հասցեի վրա, եթե թողնված է դատարկ։',
        oneToOneTitle: '1:1 NAT կանոններ',
        oneToOneHint: 'Արտաքին հասցեի ամեն փաթեթ արտապատկերվում է ներքինի վրա, և ներքին հոսթը դուրս է գալիս որպես արտաքինը — բոլոր արձանագրությունները, երկու ուղղությունները։',
        external: 'Արտաքին հասցե',
        internal: 'Ներքին հասցե',
        addOneToOne: 'Ավելացնել 1:1 կանոն',
        family: 'Ընտանիք',
        protocol: 'Արձանագրություն',
        source: 'Աղբյուր (հասցե/ենթացանց)',
        destination: 'Նշանակետ (հասցե/ենթացանց)',
        invert: 'NOT',
        srcPorts: 'Աղբյուրի պորտեր',
        dstPorts: 'Նշանակետի պորտեր',
        dstPortsHint: 'Պորտ կամ միջակայք (80, 8000-8099)',
        toAddress: 'Նոր հասցե',
        toPort: 'Նոր պորտ',
        snatTo: 'Նոր աղբյուր (դատարկ = masquerade)',
        snatToHint: 'Բացահայտ աղբյուրի հասցե. դատարկ = masquerade ելքի հասցեի վրա',
        addDnat: 'Ավելացնել DNAT կանոն',
        addSnat: 'Ավելացնել SNAT կանոն',
        routesTitle: 'Ստատիկ երթուղիներ',
        routesHint: 'Հանգույցը երթուղավորում է իրեն կցված ցանցերի միջև (IP forwarding-ը միացված է). այս երթուղիներն ավելացնում են հասանելիություն դրանցից դուրս — մաքուր միջուկ, դինամիկ երթուղավորումը գալիս է հաջորդ ռաունդներից մեկով։',
        routeDestination: 'Նշանակետի ենթացանց',
        routeGateway: 'Next hop',
        routeMetric: 'Մետրիկա',
        addRoute: 'Ավելացնել երթուղի',
        listening: 'Ունկնդրում է',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} երթուղի'
      },
      unknownSince: 'Անհայտ — վերջին հաշվետվությունը {m} րոպե առաջ',
      lastWord: 'Վերջին խոսքը',

      // Ռաունդ #156 (ստանդարտ երկխոսություն). դիտարկված տողերը և kind բլոկի
      // միայն-ընթերցվող ամփոփումը մանրամասների երկխոսությունում:
      reportObservedAt: 'Վերջին հաշվետվություն',
      lastErrorRow: 'Վերջին սխալը',
      recordsCount: '{n} ձեռքով գրառում',
      phase: {
        configured: 'Կարգավորված',
        running: 'Կատարվում է',
        error: 'Սխալ'
      },
      authorityNode: 'Պատասխանատու հանգույց (նշանակում)',
      preferredNode: 'Նախընտրելի հանգույց',
      preferredNodeHint: 'Փափուկ նախապատվություն, երբեք ոչ պարտադրանք. տեղաբաշխման հաջորդ որոշման ժամանակ ինստանսը վայրէջք է կատարում այստեղ, եթե անդամը պիտանի է — ինքնին այն ոչինչ չի տեղաշարժում. քայլը «Փոխանցել պատասխանատվությունը» գործողությունն է։',
      noPreference: 'Նախապատվություն չկա (ավտոմատ տեղաբաշխում)',
      moving: 'Տեղափոխման մեջ',
      movingTooltip: 'Դիտարկվում է այստեղ, քանի դեռ պատասխանատվությունը նշանակում է {node}. տեղափոխությունը մոտենում է ավարտին։',
      placement: {
        title: 'Տեղաբաշխում',
        loading: 'Հաշվառումն ընթացքի մեջ է…',
        loadError: 'Տեղաբաշխման հաշվառումը չպատասխանեց — փորձեք ավելի ուշ։',
        draftHint: 'Հաշվառումը հաշվարկվում է հայտարարված ցանցային միացումից. այն կհայտնվի ծառայությունը ստեղծվելուն պես։ Ստեղծումը մերժվում է, եթե ոչ մի անդամ չի կարող սպասարկել այն, և մերժումը նշում է այն մեխանիզմը, որը դատարկեց բազմությունը։',
        eligibleCount: '{m} անդամից {n}-ը կարող են սպասարկել այս ինստանսը',
        recommended: 'Խորհուրդ է տրվում',
        eligible: 'Պիտանի',
        notEligible: 'Պիտանի չէ',
        blockedReachability: 'ցանցը չի հասնում այս անդամին',
        blockedRequireTag: 'արգելափակված է պահանջվող թեգով (requireNodes)',
        blockedExcluded: 'բացառված է սիմուլյացիայից',
        preferenceUnknown: 'այն (այլևս) կլաստերի անդամ չէ',
        preferenceIgnored: '«{node}» նախապատվությունն այսօր պիտանի չէ՝ {reason}։ Գերակշռում է հաշվառման առաջարկը — երբեք սխալ չէ, ծառայությունն ապրում է այլուր։',
        emptyReachability: 'Ոչ մի անդամ չի կարող սպասարկել այս ինստանսը. ցանցը ոչ մի տեղ չի հասնում — թեգերի ոչ մի շտկում չի օգնի։ Մալուխով միացրեք հանգույցը կամ տեղափոխեք ծառայությունն այնտեղ, որտեղ ցանցը կա։',
        emptyRequireTag: 'Ոչ մի անդամ չի կարող սպասարկել այս ինստանսը. հենց պահանջվող թեգերն են դատարկել բազմությունը — հեռացրեք գրառումը requireNodes-ից կամ թեգ դրեք որևէ անդամի վրա։',
        spof: 'Ձախողման միակ կետ',
        spofDetail: 'Միայն մեկ անդամ կարող է հյուրընկալել ինստանսը. ձախողման դեպքում վթարային փոխարկումը գնալու տեղ չունի։ Բազմակի ունկնդիրներով ծառայությունը տեղափոխվում է որպես ՄԵԿ ԱՄԲՈՂՋՈՒԹՅՈՒՆ — թեկնածուն պետք է տեսնի նրա ԲՈԼՈՐ ցանցերը. սա է գինը։',
        whatIf: 'Սիմուլացնել բացակա անդամներին',
        whatIfHint: 'Դատարկման what-if-ը. հարցրեք տարհանումից ԱՌԱՋ, մի բացահայտեք դա վթարային փոխարկման պահին։',
        survives: '{nodes} բացակայելիս ծառայությունը դեռ տուն ունի։',
        notSurvives: '{nodes} տարհանելը թողնում է այս ծառայությունն ԸՆԿԱԾ. ածանցյալ սահմանափակումը հաղթում է հասանելիությանը (R30) — դեմոնը, որ ողջ է այնտեղ, ուր ցանցը չի հասնում, ոչ մեկին չի ծառայում և ոչ մեկին չի ահազանգում։',
        transfer: 'Փոխանցել պատասխանատվությունը',
        transferError: 'Փոխանցումը ձախողվեց',
        transferTarget: 'Նպատակակետ անդամ',
        transferHint: 'Առաջարկվում են միայն պիտանի անդամները — նախապատվություն վավեր բազմության ներսում, երբեք ոչ override։ Ոչ մի առաջադրանք. վորկերների հաջորդ անցումը ՀԵՆՑ տեղափոխությունն է (հին հանգույցը հնձում է, նորը՝ կառուցում)։'
      }
    },
    fabric: {
      tabDerivation: 'Ածանցում',
      importNetwork: 'Ներմուծել այլ fabric-ից',
      importTitle: 'Ներմուծել տրամաբանական ցանց',
      importHint: 'Ներմուծումը բացահայտ միանալն է. ցանցը մնում է սեփականատիրոջը (նույն ինքնությունը, նույն stem-ը, նույն tvf-<stem> bridge-ը) և այստեղից քարտեզագրվում է այս fabric-ի պորտերին/LAGG-երին. քարտեզագրելը ՆՇԱՆԱԿՈՒՄ Է պնդել, որ առաքումը դուրս է գալիս նույն L2 տիրույթ, ինչ սեփականատիրոջը:',
      importPick: 'Սեփականատիրոջ ցանցը',
      importNone: 'Ներմուծելու բան չկա. մյուս fabric-ները չունեն սեփական ցանց, որն այս fabric-ն արդեն չճանաչի',
      importedNetworksTitle: 'Ներմուծված ցանցեր',
      noImported: 'Ներմուծված ցանց չկա',
      importedFrom: 'ներմուծված է {fabric}-ից',
      importedBy: 'Ներմուծել են՝ {list}',
      importedCount: '+{n} ներմուծված',
      owner: 'Սեփականատեր',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Հեռացնել ներմուծումը',
      unimportConfirm: 'Հեռացնե՞լ {name} ցանցի (սեփականատեր՝ {fabric}) ներմուծումն այս fabric-ից: Մերժվում է, քանի դեռ այս fabric-ի որևէ պորտ կամ LAGG քարտեզագրում է այն, կամ որևէ guest, App կամ ծառայություն սպասարկվում է միայն այս ոտքի միջոցով:',
      unimportRefused: 'Ներմուծումը դեռ օգտագործվում է — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Այս հանգույցն այդ ցանցն արդեն ստանում է մեկ այլ fabric-ից, որի անդամ է. հանգույցը կիսվող ցանցը վերցնում է իր ոտքերից միայն ՄԵԿՈՎ (նույն L2-ի երկու uplink առանց STP bridge-ում օղակ է): Հանիր քարտեզագրումը երկու fabric-ներից մեկի պորտերի կամ LAGG-ի վրա:',
          otherFabricDerived: 'Փաստաթուղթը կրում է այնպիսի fabric-ի բլոկ, որի ուղղությամբ հանգույցն այլևս մալուխ չի հայտարարում. նախ կիրառիր այդ fabric-ի պլանը (այն առաջարկում է հեռացնել դրա սարքերը), կամ տիրապետիր դրանց take-ownership-ով, եթե fabric-ն այլևս չկա:'
        },
        hint: 'O.3 ածանցման պլանը. յուրաքանչյուր մալուխավորված հանգույցի համար՝ վիճակը, ածանցյալ-vs-ընթացիկ diff-ը, ՀԱՅՏԱՐԱՐՎԱԾ bond տոպոլոգիան, dual-stack ֆլիփերը և կառուցվածքային մերժումները/զգուշացումները։ Միայն ընթերցում մինչև ԲԱՑԱՀԱՅՏ apply-ը — ոչինչ երբեք ինքնուրույն չի իջնում հանգույցի վրա։',
        refresh: 'Վերբեռնել պլանը',
        empty: 'Ոչ մի հանգույց մալուխավորված չէ այս fabric-ին (և ոչ մեկն այլևս չի կրում նրա բլոկը)։',
        refusal: 'Մերժում',
        warning: 'Զգուշացում',
        generation: 'փաստաթղթի սերունդ {n}',
        state: {
          manual: 'Ձեռքով',
          derived: 'Ածանցյալ',
          diverged: 'Շեղված'
        },
        topologyTitle: 'Հայտարարված տոպոլոգիա',
        members: 'անդամներ',
        primary: 'առաջնային',
        held: 'պահված ՄԵԿ անդամի վրա',
        form: {
          perNetworkBond: 'Bond յուրաքանչյուր ցանցի համար',
          singleBond: 'Մեկ պահուստային bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Մեկ պորտ'
        },
        colAction: 'Գործողություն',
        colKind: 'Տեսակ',
        colDevice: 'Device',
        colDetail: 'Մանրամասն',
        action: {
          add: 'ավելացնել',
          remove: 'հեռացնել',
          replace: 'փոխարինել'
        },
        diffEmpty: 'Սպասվող diff չկա — կիրառված փաստաթուղթը համընկնում է render-ի հետ։',
        diffBlocked: 'Diff չկա. վերևի մերժումները արգելափակում են այս հանգույցը։',
        phasePlanned: 'պլանավորված (քայլ 1-ը 3-ից)',
        phaseDraining: 'դատարկվում է (քայլ 2-ը 3-ից)',
        probeUnobserved: 'Դատարկման զոնդ. երբեք չի հաղորդվել — դատարկությունը ԱՆՀԱՅՏ Է (retire-ը հիմա կմերժվեր)։',
        probeFailed: 'Դատարկման զոնդ. դիտարկումը ՁԱԽՈՂՎԵՑ — հայտնի ժամանակակնիքները փոխանցվում են, երբեք «դատարկ», որը ոչ ոք չի չափել։',
        probeActive: {
          one: 'Զոնդ. {n} հաստատված կապ դեռ հին հասցեի վրա',
          other: 'Զոնդ. {n} հաստատված կապ դեռ հին հասցեի վրա'
        },
        probeLastActive: 'վերջին ակտիվություն {time}',
        probeEmpty: {
          one: 'Զոնդ. դատարկ {n} րոպե',
          other: 'Զոնդ. դատարկ {n} րոպե'
        },
        probeEmptyUnknown: 'Զոնդ. դատարկ (որ պահից՝ անհայտ)։',
        impact: '{nics} vNIC և {apps} App այս հանգույցի վրա օգտագործում են այս ցանցերը. {list}',
        apply: 'Կիրառել այս հանգույցի վրա',
        applyTitle: 'Կիրառել ածանցումը — {node}',
        applyIntro: 'Ածանցյալ կոնֆիգուրացիան վերագրում է {node}-ի ցանցային փաստաթուղթը ({n} փոփոխություն) նույն դռնով, ինչ host-network խմբագրիչը — ներառյալ NetworkManager checkpoint-ը և ազնիվ զոնդը։ Պլանի զգուշացումները ներքևում ճամփորդում են ակտի հետ. կարդացեք դրանք հաստատելուց առաջ։',
        applyError: 'Apply-ը ձախողվեց',
        applyRefused: 'Հանգույցը մերժեց.',
        planMoved: 'Fabric-ը փոխվել է այս նախադիտումից հետո — ՈՉԻՆՉ չի կիրառվել։ Պլանը վերբեռնվել է. նայեք նորից և կրկին փորձեք։',
        retire: 'Հանել',
        retireTitle: 'Անվերադարձ կետ — {address}-ի հանում',
        restore: 'Վերականգնել',
        restoreTip: 'Վերադարձ apply-ից առաջ արված պատկերին (սերունդ {previous}) — մեկ քայլով հետարկում (H13)',
        restoreTitle: 'Վերականգնել նախորդ փաստաթուղթը — {node}',
        restoreIntro: '{node}-ի ցանցային փաստաթուղթը վերադառնում է վերջին apply-ից առաջ արված պատկերին (սերունդ {previous})՝ վերագրված որպես սերունդ {next} {current}-ի փոխարեն։ Worker-ը այն համաձայնեցնում է ինչպես ցանկացած այլ փաստաթուղթ։',
        restoreRedo: 'Փոխարինված փաստաթուղթը դառնում է նոր պատկերը․ նորից վերականգնելը redo-ն է։',
        restoreClosesChain: 'Պատկերը ածանցումից առաջ եղած ձեռքով փաստաթուղթն է․ շղթան փակվում է այստեղ — այլ հետարկում չկա, հանգույցը ձեռքով է մինչև հաջորդ apply-ը։',
        restoreConfirm: 'Վերականգնել',
        restoreError: 'Վերականգնումը ձախողվեց',
        retireIntro: 'Սա վերջնականապես հեռացնում է {address}-ը ({network}) {point}-ից։ Այս ակտից հետո վերադարձի ճանապարհը ՀԱԿԱԴԱՐՁ ֆլիփն է — հին հասցեի վերահայտարարումը նույն շարժիչով — երբեք կույր վերականգնում։',
        retireOld: 'Հին հասցե (հեռացված)',
        retireNew: 'Նոր հասցե (մնում է)',
        retireEmptyFact: 'Դատարկման զոնդը հաղորդում է հասցեն դատարկ. այս հեռացումը չի կտրում ոչ մի դիտարկված կապ։',
        retireConfirm: 'Հանել հասցեն',
        severActiveLoss: {
          one: 'Կտրել {n} հաստատված կապ դեռ հին հասցեի վրա — այն մահանում է այս ակտով',
          other: 'Կտրել {n} հաստատված կապ դեռ հին հասցեի վրա — դրանք մահանում են այս ակտով'
        },
        severUnknownLoss: 'Ընդունել ԱՆՀԱՅՏԸ. զոնդը երբեք չի դիտարկել այս հասցեն (կամ դիտարկումը ձախողվում է) — կենդանի կապերը կարող են կտրվել։'
      },
      title: 'Ֆաբրիկա',
      createTitle: 'Ստեղծել ֆաբրիկա',
      networks: 'Ցանցեր',
      switches: 'Կոմուտատորներ',
      ports: 'Պորտեր',
      laggs: 'LAGG-եր',
      subnets: 'Ենթացանցեր',
      tabOverview: 'Ընդհանուր պատկեր',
      tabNetworks: 'Տրամաբանական ցանցեր',
      tabSwitches: 'Կոմուտատորներ',
      overviewHint: 'Ֆաբրիկան մի հայացքով. ամեն տրամաբանական ցանց՝ իր MTU-ով և ենթացանցով (VLAN-ներն ապրում են միայն ըստ պորտի/ըստ LAGG-ի քարտեզագրումներում — նույն ցանցը տարբեր պորտերի վրա կարող է գնալ տարբեր թեգերով)։ Ֆաբրիկան ԱՐՏԱՔԻՆ ենթակառուցվածքի ռեգիստր է — TVirt-ը դիտարկում և հայտարարում է, երբեք չի տրամադրում, և դիպչում է միայն իր վերահսկողության տակ գրանցված NIC-երին։',
      absorptionHint: 'Այստեղ հայտարարված ամեն ենթացանց նույն գրառմամբ ԱԾԱՆՑՈՒՄ Է իր գրառումը IPAM ռեգիստրում — ապրում և մեռնում է ցանցի հետ։',
      scopeFixedHint: 'Սկոուպը ամրագրված է կլաստերի արմատին. ֆիզիկական ենթակառուցվածքը ըստ սահմանման ամբողջ կլաստերինն է:',
      networksHint: 'Ամեն ցանց կրում է պարտադիր MTU (լռելյայն 1500) և պարտադիր ենթացանց. այստեղ հայտարարված դարպասը, DNS սերվերները և ստատիկ երթուղիները ՄԻԱԿ ԱՂԲՅՈՒՐՆ են սերվերների NIC-երի, հավելվածների և ցանցային ծառայությունների համար։',
      switchesHint: 'Ձեռքով վարվող ռեգիստրը. պորտը կա՛մ չօգտագործված է, կա՛մ քարտեզագրված (untagged և ըստ VLAN թեգի թրաֆիկը տրամաբանական ցանցերի վրա), կա՛մ LAGG-ի անդամ — անդամը սեփական քարտեզագրումներ չի կրում։',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Պարտադիր է — IPAM-ն ինքնաբերաբար ածանցում է իր ռեգիստրի գրառումը',
      nodeAddressing: 'Հանգույցների հասցեավորում',
      nodeAddressingNone: 'Ոչ մի — հանգույցին հասցե չի տրվում',
      nodeAddressingPool: 'Pool — մեկ կայուն հասցե յուրաքանչյուր սպասարկվող հանգույցի համար',
      nodeAddressingHint: 'Pool-ի դեպքում fabric-ի ածանցումը յուրաքանչյուր սպասարկվող հանգույցին հատկացնում է հասցե TVirt-ի համար վերապահված միջակայքերից (հատկացումից հետո կայուն)։',
      backing: 'Backing',
      gateway: 'Դարպաս',
      ranges: 'Վերապահված միջակայքեր',
      dns: 'DNS սերվերներ (ստորակետով բաժանված)',
      dnsShort: 'DNS',
      singleSourceHint: 'Այստեղ հայտարարված դարպասը, DNS-ը և երթուղիները միակ աղբյուրն են — սերվերների NIC-երը, հավելվածները և ցանցային ծառայությունները վերցնում են այստեղից',
      routesTitle: 'Ստատիկ երթուղիներ',
      routeDestination: 'Նշանակետ (CIDR)',
      routeVia: 'Միջոցով (next hop)',
      portUsed: 'Օգտագործված',
      vlanMappings: 'VLAN քարտեզագրումներ',
      vlanTag: 'VLAN թեգ',
      vlanNetwork: 'Տրամաբանական ցանց',
      nameTaken: 'Այս անունն արդեն օգտագործված է ֆաբրիկայում',
      addNetwork: 'Ավելացնել ցանց',
      editNetwork: 'Խմբագրել ցանցը',
      deleteNetwork: 'Հեռացնել ցանցը',
      deleteNetworkConfirm: 'Հեռացնե՞լ {name} տրամաբանական ցանցը ֆաբրիկայից։ Նրա ածանցված IPAM ենթացանցը մեռնում է նրա հետ (մերժվում է, քանի դեռ ծառայություն կամ հավելված օգտագործում է այն)։ Դրան մատնանշող պորտերի և LAGG-երի քարտեզավորումները մաքրվում են:',
      switchName: 'Կոմուտատոր',
      portName: 'Պորտ',
      positionHint: 'Ֆիզիկական դիրք (ոչ պարտադիր) — նույն բառապաշարը, ինչ սերվերների տեղադրության համար. միայն հայտարարագրային',
      addSwitch: 'Ավելացնել կոմուտատոր',
      editSwitch: 'Խմբագրել կոմուտատորը',
      deleteSwitch: 'Հեռացնել կոմուտատորը',
      deleteSwitchConfirm: 'Հեռացնե՞լ {name} կոմուտատորն իր բոլոր պորտերով։ LAGG-երը համապատասխանաբար կծկվում են (և երկու պորտից պակասի դեպքում մեռնում են)։',
      addPort: 'Ավելացնել պորտ',
      editPort: 'Խմբագրել պորտը',
      deletePort: 'Հեռացնել պորտը',
      deletePortConfirm: 'Հեռացնե՞լ {name} պորտը',
      untagged: 'Untagged',
      tagged: 'Tagged (թեգ:ցանց)',
      taggedShort: 'Tagged',
      portCabling: 'Մալուխավորում',
      portState: 'Վիճակ',
      stateUnused: 'չօգտագործված',
      stateMapped: 'քարտեզագրված',
      laggPortGuard: 'LAGG-ի անդամ պորտը խմբագրվում է LAGG-ի կողմից',
      laggsTitle: 'LAGG-եր',
      laggsHint: 'LAGG-ը 2+ պորտ է LACP-ով և կարող է ձգվել կոմուտատորների միջով (MLAG, թափանցիկ). միանում են միայն չօգտագործված պորտերը, LAGG-ը քարտեզագրման մակերեսն է, հեռացված պորտը վերադառնում է չօգտագործվածի։',
      addLagg: 'Ավելացնել LAGG',
      editLagg: 'Խմբագրել LAGG-ը',
      deleteLagg: 'Հեռացնել LAGG-ը',
      deleteLaggConfirm: 'Հեռացնե՞լ {name} LAGG-ը։ Նրա անդամ պորտերը վերադառնում են չօգտագործվածի։',
      lacpRate: 'LACP տեմպ',
      laggPorts: 'Անդամ պորտեր (2+)',
      laggPortsHint: 'Միանում են միայն չօգտագործված պորտերը — նախ ազատեք քարտեզագրված պորտը',
      noNetworks: 'Հայտարարված տրամաբանական ցանցեր չկան։',
      noSwitches: 'Հայտարարված կոմուտատորներ չկան։',
      noLaggs: 'Հայտարարված LAGG-եր չկան։',
      staleConflict: 'Մեկ այլ օպերատոր փոփոխեց այս ֆաբրիկան, մինչ դու այն խմբագրում էիր. պահպանումը մերժվեց, որպեսզի նրա աշխատանքը չջնջվի։ Քո փոփոխությունները դեռ այստեղ են, անձեռնմխելի։ Թարմացված ֆաբրիկան արդեն վերաբեռնվել է. հաստատիր կրկին՝ դրանք վրան կիրառելու համար, կամ չեղարկիր և նայիր՝ ինչն է փոխվել։'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Միայն ածանցված. ամեն ենթացանց ծնվում է ֆաբրիկայի տրամաբանական ցանցից կամ օվերլեյից — խմբագրվում է իր աղբյուրում։ Նշանակված հասցեները ցույց են տալիս, թե ՈՎ է պահում դրանք. TVirt-ին վերապահված միջակայքերը ավտոմատ նշանակման պուլերն են։',
      search: 'Որոնում ըստ անվան, CIDR-ի կամ հասցեի',
      empty: 'Ցանցեր չկան — հայտարարեք ֆաբրիկայի տրամաբանական ցանց կամ օվերլեյ ենթացանց. IPAM-ն ինքնաբերաբար ածանցվում է դրանցից։',
      reserved: 'TVirt-ին վերապահված միջակայքեր',
      address: 'Հասցե',
      origin: 'Ծագում',
      origin_declared: 'հայտարարված',
      origin_observed: 'դիտարկված',
      holder: 'Պահողը',
      noAddresses: 'Այս ենթացանցում դեռ հայտնի հասցեներ չկան։',
      sourceFabric: 'Ֆաբրիկա',
      sourceOverlay: 'Օվերլեյ',
      editAtSource: 'Խմբագրել աղբյուրում'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Ֆայրվոլի խմբեր',
      createTitle: 'Ֆայրվոլի նոր խումբ',
      editTitle: 'Խմբագրել ֆայրվոլի խումբը',
      empty: 'Դեռ ֆայրվոլի խումբ չկա — ստեղծեք մեկը. կանոնների վերաօգտագործելի բառապաշար, որին հյուրերի NIC-երը հղվում են անունով։',
      nameHint: 'Տառեր, թվանշաններ և ներքին . - _; եզակի իր սկոուպի ներսում (այլուր համանունները տարբերվում են /scope/անուն-ով)',
      description: 'Նկարագրություն',
      descriptionHint: 'Մեկ տող մտադրություն. ցուցադրվում է ամենուր, որտեղ խումբն ընտրվում է',
      enforced: 'Պարտադրված սկոուպին',
      enforcedHint: 'Անջատված՝ մաքուր բառապաշար — կանոնները կապում են միայն այն NIC-երը, որոնք հղվում են խմբին։ Միացված՝ կանոնները կապում են խմբի սկոուպի տակ գտնվող ամեն հյուրի NIC, որի ֆայրվոլը միացված է՝ հղված թե ոչ։',
      enforcedChip: 'Պարտադրված',
      enforcedChipHint: 'Կանոնները կապում են խմբի սկոուպի տակ գտնվող ամեն հյուրի NIC, որի ֆայրվոլը միացված է՝ հղված թե ոչ',
      enforceWarning: 'Պարտադրումը միացնելով՝ կանոնները հաջորդ հավասարեցման ժամանակ կապում են {scope}-ի տակ գտնվող ԱՄԵՆ հյուրի NIC, որի ֆայրվոլը միացված է՝ նույնիսկ առանց բացահայտ հղման, իսկ ակտիվ chain-ի ներսում նախնու drop-ը վերջնական է. ներքևի մակարդակները այն չեն վերաբացում։',
      unenforceInfo: 'Պարտադրումը հանելով՝ կանոնները մնում են միայն այն NIC-երի վրա, որոնք բացահայտորեն հղվում են խմբին։',
      rules: 'Կանոններ',
      tabOverview: 'Ընդհանուր պատկեր',
      tabRules: 'Կանոններ',
      orderHint: 'Տողերի հերթականությունը ՀԵՆՑ խմբի ներսում գնահատման հերթականությունն է. հաղթում է առաջին համընկնող կանոնը։',
      statefulHint: 'Stateful-ը ենթադրյալ է. թույլատրված թրաֆիկի պատասխաններն անցնում են ինքնուրույն (established/related-ն ընդունվում է, invalid-ը դեն է գցվում — դրանք ներարկում է շարժիչը, ձեռքով չեն գրվում)։',
      noRules: 'Կանոններ չկան — կառուցվող բառապաշար. դրան հղվելը թույլատրելի է և ոչինչ չի արտադրում։',
      addRule: 'Ավելացնել կանոն',
      direction: 'Ուղղություն',
      directionIn: 'Մուտքային',
      directionOut: 'Ելքային',
      action: 'Գործողություն',
      action_accept: 'Ընդունել',
      action_drop: 'Դեն գցել',
      action_reject: 'Մերժել',
      protocol: 'Պրոտոկոլ',
      protocolAny: 'Ցանկացած',
      ports: 'Պորտեր',
      source: 'Աղբյուր',
      dest: 'Նպատակակետ',
      comment: 'Մեկնաբանություն',
      addressHint: 'IPv4 CIDR կամ <ֆաբրիկա>/<տրամաբանական ցանց>. դատարկ = ցանկացած',
      moveUp: 'Տեղափոխել վերև',
      moveDown: 'Տեղափոխել ներքև',
      nicFirewall: 'Ֆայրվոլ',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Ֆայրվոլի խմբեր',
      nicGroupsPlaceholder: 'Ընտրեք խումբ…',
      nicGroupsHint: 'Տեսանելի խմբերը՝ ներառյալ վերադաս սկոուպներինը (օգտագործելի են դեպի ներքև, ինչպես թեգերը)',
      nicGroupCount: { one: '{n} ֆայրվոլի խումբ', other: '{n} ֆայրվոլի խումբ' },
      nicOff: 'Ֆայրվոլն անջատված է',
      pendingRestartHint: 'Ֆայրվոլի փոփոխությունները հետևում են պահված/կիրառված մոդելին. սպասում են հաջորդ սնուցման ցիկլին (PendingRestart)։ Վերադաս սկոուպներից պարտադրված խմբերը կիրառվում են, երբ NIC-ի ֆայրվոլը միացված է։',
      appConvergeHint: 'Ֆայրվոլի փոփոխությունները կիրառվում են կոնտեյների հաջորդ հավասարեցման ժամանակ։ Վերադաս սկոուպներից պարտադրված խմբերը կիրառվում են, երբ ֆայրվոլը միացված է։',
      enforcedAncestors: 'Պարտադրված վերադաս սկոուպներից',
      enforcedAncestorsHint: 'Այս խումբը կիրառվում է իր սկոուպի տակ գտնվող ամեն NIC-ի վրա, որի ֆայրվոլը ՄԻԱՑՎԱԾ է — փոխանջատիչը NIC-ի գլխավոր անջատիչն է (անջատված = ոչ մի chain, նախնիները ներառյալ). ակտիվ chain-ի ներսում նախնու հեղինակությունը վերջնական է. նրա drop-ը ներքևում չի վերաբացվում։'
    }
  }
}
